var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":"https://assets.invisee.com/statis/revamp/header-img.jpg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }